import React from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import PropTypes from 'prop-types';

const CheckboxContainer = styled.div`
	display: inline-flex;
	align-items: center;
	vertical-align: middle;
`;

const Icon = styled.svg`
	fill: none;
	stroke: ${({ theme }) => theme['white']};
	stroke-width: 3px;
	vertical-align: baseline;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
	position: absolute;
	margin: -1px;
	padding: 0;
	width: 1px;
	height: 1px;
	overflow: hidden;
	white-space: nowrap;
	clip: rect(0 0 0 0);
	clip-path: inset(50%);
`;

const StyledCheckbox = styled.div`
	display: inline-block;
	transition: all 150ms;
	border-radius: 2px;
	background: ${({ theme, ...props }) => {
	return props.checked ? theme['blue-base'] : theme['white'];
}};
	width: 16px;
	height: 16px;

	${HiddenCheckbox}:focus + & {
		box-shadow: 0 0 0 0.2rem ${({ theme }) => rgba(theme['blue-base'], 0.5)};
	}

	${Icon} {
		visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
	}
`;

export const CheckboxLabel = styled.span`
	margin-left: 0.5rem;
`;

const Checkbox = ({ className, checked, ...props }) => (
	<CheckboxContainer className={className}>
		<HiddenCheckbox checked={checked} {...props} />
		<StyledCheckbox checked={checked}>
			<Icon viewBox="0 0 24 24">
				<polyline points="20 6 9 17 4 12" />
			</Icon>
		</StyledCheckbox>
	</CheckboxContainer>
);
Checkbox.propTypes = {
	className: PropTypes.string,
	checked: PropTypes.bool
};
export default Checkbox;
